module.exports = __webpack_public_path__ + "static/responsibility-bc9a445b8ee56dc702b0bd7f618fb1fa.png";